export const pluralize = (word: string, count: number) => (count === 1 ? word : `${word}s`)
export const capitalizeStrings = (str: string) =>
  str
    .split(' ')
    .map(val => val[0].toUpperCase() + val.substring(1).toLowerCase())
    .join(' ')
